
import LogicBaseStoriesCache from '../cache/LogicBaseStoriesCache';
import UserAccount from '../UserAccount';
import AssetCache from '../cache/AssetCache';
import SpreadsheetCache from '../cache/SpreadsheetCache';
import DatabaseCache from '../cache/DatabaseCache';
import DatabaseCollectionCache from '../cache/DatabaseCollectionCache';
import DatabaseCollectionDocumentCache from '../cache/DatabaseCollectionDocumentCache';
import TreeCache from '../cache/TreeCache';
import CompanyCache from '../cache/CompanyCache';
import LogicBaseCollectionCache from '../cache/LogicBaseCollectionCache';
import LogicBaseRelationshipCache from '../cache/LogicBaseRelationshipCache';
import LogicBaseUserCache from '../cache/LogicBaseUserCache';
import LogicBaseAppPinCache from '../cache/LogicBaseAppPinCache';
import LogicBaseCommentLikeCache from '../cache/LogicBaseCommentLikeCache';
import LogicBaseConversationCache from '../cache/LogicBaseConversationCache';
import LogicBaseMessageCache from '../cache/LogicBaseMessageCache';
import LogicBaseAppLikeCache from '../cache/LogicBaseAppLikeCache';
import LogicBaseCommentsCache from '../cache/LogicBaseCommentCache';
import LogicBaseCollectionSubscriptionCache from '../cache/LogicBaseCollectionSubscriptionCache';
import LogicBaseDiscoverFeedsCache from '../cache/LogicBaseDiscoverFeedsCache';
import LogicBaseFeaturedCache from '../cache/LogicBaseFeaturedCache';
import LogicBaseNotificationCache from '../cache/LogicBaseNotificationCache';
import LinkCache from '../cache/LinkCache';
import Pagination from './PaginationService';

const company = window.logictry && window.logictry.company && window.logictry.company._id || '';

export const AccountLinksOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  page: i,
}), LinkCache);

export const AccountTemplatesOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  type: 'Template',
  page: i,
}), TreeCache);
export const AccountTemplatesInvitedOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  role: 'Invited',
  type: 'Template',
  page: i,
}), TreeCache);
export const AccountTemplatesDeleted = new Pagination((i) => ({
  state: 'Deleted',
  company,
  type: 'Template',
  page: i,
}), TreeCache);
export const AccountProjectsOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  type: 'Project',
  page: i,
}), TreeCache);
export const AccountProjectsInvitedOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  role: 'Invited',
  type: 'Project',
  page: i,
}), TreeCache);
export const AccountProjectsDeleted = new Pagination((i) => ({
  state: 'Deleted',
  company,
  type: 'Project',
  page: i,
}), TreeCache);
export const AccountSpreadsheetsOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  page: i,
}), SpreadsheetCache);
export const AccountSpreadsheetsInvitedOpen = new Pagination((i) => ({
  state: 'Live',
  role: 'Invited',
  company,
  page: i,
}), SpreadsheetCache);
export const AccountSpreadsheetsDeleted = new Pagination((i) => ({
  state: 'Deleted',
  company,
  page: i,
}), SpreadsheetCache);
export const AccountDatabasesOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  page: i,
}), DatabaseCache);
export const AccountDatabasesInvitedOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  role: 'Invited',
  page: i,
}), DatabaseCache);
export const AccountDatabasesDeleted = new Pagination((i) => ({
  state: 'Deleted',
  company,
  page: i,
}), DatabaseCache);
export const AccountAssetsOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  page: i,
}), AssetCache);
export const AccountAssetsInvitedOpen = new Pagination((i) => ({
  state: 'Live',
  company,
  role: 'Invited',
  page: i,
}), AssetCache);
export const AccountAssetsDeleted = new Pagination((i) => ({
  state: 'Deleted',
  company,
  page: i,
}), AssetCache);
export const AccountCompanies = new Pagination((i) => ({
  company,
  page: i,
}), CompanyCache);



/**
 * Paginations that are cached
 */
let teamProjectsOpen = {};
export function getTeamProjectsOpen(team) {
  if (teamProjectsOpen[team]) return teamProjectsOpen[team];
  teamProjectsOpen[team] = TeamProjectsOpen(team);
  return teamProjectsOpen[team];
}
const TeamProjectsOpen = (team) => new Pagination((i) => ({
  team,
  state: 'Live',
  type: 'Project',
  page: i,
}), TreeCache);

let teamTemplatesOpen = {};
export function getTeamTemplatesOpen(team) {
  if (teamTemplatesOpen[team]) return teamTemplatesOpen[team];
  teamTemplatesOpen[team] = TeamTemplatesOpen(team);
  return teamTemplatesOpen[team];
}
const TeamTemplatesOpen = (team) => new Pagination((i) => ({
  team,
  state: 'Live',
  type: 'Template',
  page: i,
}), TreeCache);

let teamSpreadsheetsOpen = {};
export function getTeamSpreadsheetsOpen(team) {
  if (teamSpreadsheetsOpen[team]) return teamSpreadsheetsOpen[team];
  teamSpreadsheetsOpen[team] = TeamSpreadsheetsOpen(team);
  return teamSpreadsheetsOpen[team];
}
const TeamSpreadsheetsOpen = (team) => new Pagination((i) => ({
  team,
  state: 'Live',
  page: i,
}), SpreadsheetCache);

let teamDatabasesOpen = {};
export function getTeamDatabasesOpen(team) {
  if (teamDatabasesOpen[team]) return teamDatabasesOpen[team];
  teamDatabasesOpen[team] = TeamDatabasesOpen(team);
  return teamDatabasesOpen[team];
}
const TeamDatabasesOpen = (team) => new Pagination((i) => ({
  team,
  state: 'Live',
  page: i,
}), DatabaseCache);

let databaseCollections = {};
export function getDatabaseCollections(database) {
  if (databaseCollections[database]) return databaseCollections[database];
  databaseCollections[database] = DatabaseCollections(database);
  return databaseCollections[database];
}
const DatabaseCollections = (database) => new Pagination((i) => ({
  database,
  page: i,
}), DatabaseCollectionCache);

let databaseCollectionDocuments = {};
export function getDatabaseCollectionDocuments(databaseCollection) {
  if (databaseCollectionDocuments[databaseCollection]) return databaseCollectionDocuments[databaseCollection];
  databaseCollectionDocuments[databaseCollection] = DatabaseCollectionDocuments(databaseCollection);
  return databaseCollectionDocuments[databaseCollection];
}
const DatabaseCollectionDocuments = (collection) => new Pagination((i) => ({
  collection,
  limit: 20,
  offset: (i - 1) * 20,
}), DatabaseCollectionDocumentCache, 20);


let teamAssetsOpen = {};
export function getTeamAssetsOpen(team) {
  if (teamAssetsOpen[team]) return teamAssetsOpen[team];
  teamAssetsOpen[team] = TeamAssetsOpen(team);
  return teamAssetsOpen[team];
}
const TeamAssetsOpen = (team) => new Pagination((i) => ({
  team,
  state: 'Live',
  page: i,
}), AssetCache);

let templateProjects = {};
export function getTemplateProjects(referenceTree) {
  if (templateProjects[referenceTree]) return templateProjects[referenceTree];
  templateProjects[referenceTree] = TemplateProjects(referenceTree);
  return templateProjects[referenceTree];
}
const TemplateProjects = (referenceTree) => new Pagination((i) => ({
  referenceTree,
  page: i,
  count: 1000,
}), TreeCache, 1000);

let appComments = {};
export function getAppComments(app, comment) {
  const id = `${app}_${comment}`;
  if (appComments[id]) return appComments[id];
  appComments[id] = AppComments(app, comment);
  return appComments[id];
}
const AppComments = (app, comment) => new Pagination((i) => ({
  a: app,
  c: comment,
  dt: null,
  limit: 12,
  offset: (i - 1) * 12,
  sort: '-_id'
}), LogicBaseCommentsCache);

export const { getCache: getAccountAssetsSearch, initialize: initializeAccountAssetsSearch } = getSearchCache(AssetCache);
export const { getCache: getAccountSpreadsheetsSearch, initialize: initializeAccountSpreadsheetsSearch } = getSearchCache(SpreadsheetCache);
export const { getCache: getAccountTemplatesSearch, initialize: initializeAccountTemplatesSearch } = getSearchCache(TreeCache, { type: 'Template' });
export const { getCache: getAccountProjectsSearch, initialize: initializeAccountProjectsSearch } = getSearchCache(TreeCache, { type: 'Project' });
export const { getCache: getAccountDatabasesSearch, initialize: initializeAccountDatabasesSearch } = getSearchCache(DatabaseCache);
export const { getCache: getAccountDatabasecollectionsSearch, initialize: initializeAccountDatabasecollectionsSearch } = getSearchCache(DatabaseCollectionCache);
export const { getCache: getUserAppPins, initialize: initializeUserAppPins } = getCacheByKey(LogicBaseAppPinCache, 'fr', {
  sort: '-_id',
});
export const { getCache: getAppPins, initialize: initializeAppPins } = getCacheByKey(LogicBaseAppPinCache, 'a', {
  sort: '-_id',
});
export const { getCache: getAppLikes, initialize: initializeAppLikes } = getCacheByKey(LogicBaseAppLikeCache, 'a', {
  sort: '-_id',
});
export const { getCache: getCommentLikes, initialize: initializeCommentLikes } = getCacheByKey(LogicBaseCommentLikeCache, 'c', {
  sort: '-_id',
});
export const { getCache: getConversations, initialize: initializeConversations } = getCacheByKey(LogicBaseConversationCache, '', {
  sort: '-ut',
});
export const { getCache: getMessages, initialize: initializeMessages } = getCacheByKey(LogicBaseMessageCache, 'c', {
  sort: '-ct',
  dt: null,
  lsc: null,
}, 100);
export const { getCache: getLivestreamMessages, initialize: initializeLivestreamMessages } = getCacheByKey(LogicBaseMessageCache, 'c', {
  sort: '-ct',
  dt: null,
  lsc: 'livestream',
}, 100);
export const { getCache: getMeetingMessages, initialize: initializeMeetingMessages } = getCacheByKey(LogicBaseMessageCache, 'c', {
  sort: '-ct',
  dt: null,
  lsc: 'meeting',
}, 100);
export const { getCache: getVerifiedCreators, initialize: initializeVerifiedCreators } = getCacheByKey(LogicBaseUserCache, '', {
  lc: true,
  sort: '-fr',
});
/** Discover stories tray: Logic Circle creators with a published story (`lst`), newest first. */
export const { getCache: getDiscoverLogicCircleStories, initialize: initializeDiscoverLogicCircleStories } = getCacheByKey(LogicBaseUserCache, '', {
  lc: true,
  sort: '-lst',
}, 24);
export const { getCache: getUserFollowRequests, initialize: initializeUserFollowRequests } = getCacheByKey(LogicBaseRelationshipCache, 'fe', {
  r: true,
  sort: '-_id',
});
export const { getCache: getUserFollowers, initialize: initializeUserFollowers } = getCacheByKey(LogicBaseRelationshipCache, 'fe', {
  r: false,
  sort: '-_id',
});
export const { getCache: getUserFollowees, initialize: initializeUserFollowees } = getCacheByKey(LogicBaseRelationshipCache, 'fr', {
  r: false,
  sort: '-_id',
});
/** Home feed: followees sorted by last activity (bumped by `bur` on post/pin). */
export const { getCache: getFeedFollowees, initialize: initializeFeedFollowees } = getCacheByKey(LogicBaseRelationshipCache, 'fr', {
  r: false,
  sort: '-ut',
});
/** Home feed stories tray: accepted relationships (`r: false`), newest story first (`lst`). */
export const { getCache: getFeedStoriesRelationships, initialize: initializeFeedStoriesRelationships } = getCacheByKey(LogicBaseRelationshipCache, 'fr', {
  r: false,
  sort: '-lst',
}, 24);

/** Home feed: collections owned by a followee (used for per-followee fan-in).
 *  No `ss` filter — viewers can see any collection a followee owns that the server
 *  returns to them; server-side read auth/password checks still apply. */
export const { getCache: getFeedCollectionsByOwner, initialize: initializeFeedCollectionsByOwner } = getCacheByKey(LogicBaseCollectionCache, 'o', {
  dt: null,
  sort: '-_id',
}, 6);
export const { getCache: getDiscoverTrendingCollections, initialize: initializeDiscoverTrendingCollections } = getCacheByKey(LogicBaseDiscoverFeedsCache, '', {
  dfeed: 'trendingCollections',
}, 24);
/** Homepage hero. Active featured rows, newest `ut` first. Page size matches collection app rails. */
export const { getCache: getHomeFeatured, initialize: initializeHomeFeatured } = getCacheByKey(LogicBaseFeaturedCache, '', {
  dt: null,
  sort: '-ut',
}, 12);
export const { getCache: getStoriesByOwner, initialize: initializeStoriesByOwner } = getCacheByKey(LogicBaseStoriesCache, 'o', {
  sort: '-ct',
}, 12);
export const { getCache: getNotifications, initialize: initializeNotifications } = getCacheByKey(LogicBaseNotificationCache, '', {
  sort: '-_id',
});
export const { getCache: getCollectionSubscribers, initialize: initializeCollectionSubscribers } = getCacheByKey(LogicBaseCollectionSubscriptionCache, 'c', {
  dt: null,
  sort: '-_id',
});
export const { getCache: getCollectionsSubscribed, initialize: initializeCollectionsSubscribed } = getCacheByKey(LogicBaseCollectionSubscriptionCache, 'fr', {
  dt: null,
  sort: '-ut',
});
export const { getCache: getCollectionSubscribersEmails, initialize: initializeCollectionSubscribersEmails } = getCacheByKey(LogicBaseCollectionSubscriptionCache, 'c', {
  es: true,
  dt: null,
  sort: '-_id',
});
export const { getCache: getCollectionSubscribersUnsubscribed, initialize: initializeCollectionSubscribersUnsubscribed } = getCacheByKey(LogicBaseCollectionSubscriptionCache, 'c', {
  es: true,
  dn: true,
  dt: null,
  sort: '-_id',
});
export const { getCache: getAppCollections, initialize: initializeAppCollections } = getCacheByKey(LogicBaseCollectionCache, 'a', {
  dt: null,
  sort: '-_id',
});
export const { getCache: getAccountCollections, initialize: initializeAccountCollections } = getCacheByKey(LogicBaseCollectionCache, ['o', 'e'], {
  condition: 'or',
  dt: null,
  sort: '-ut',
});

function resetPaginationSessionCaches() {
  teamProjectsOpen = {};
  teamTemplatesOpen = {};
  teamSpreadsheetsOpen = {};
  teamDatabasesOpen = {};
  databaseCollections = {};
  databaseCollectionDocuments = {};
  teamAssetsOpen = {};
  templateProjects = {};
  appComments = {};
}

function initializePaginationCaches() {
  AccountTemplatesOpen.initialize();
  AccountTemplatesDeleted.initialize();
  AccountProjectsOpen.initialize();
  AccountProjectsDeleted.initialize();
  AccountSpreadsheetsOpen.initialize();
  AccountSpreadsheetsDeleted.initialize();
  AccountAssetsOpen.initialize();
  AccountAssetsDeleted.initialize();
  AccountCompanies.initialize();
  initializeUserAppPins();
  initializeAppPins();
  initializeAppLikes();
  initializeCommentLikes();
  initializeConversations();
  initializeMessages();
  initializeVerifiedCreators();
  initializeAccountAssetsSearch();
  initializeAccountSpreadsheetsSearch();
  initializeAccountDatabasecollectionsSearch();
  initializeAccountDatabasesSearch();
  initializeAccountProjectsSearch();
  initializeAccountTemplatesSearch();
  initializeUserFollowRequests();
  initializeUserFollowers();
  initializeUserFollowees();
  initializeNotifications();
  initializeCollectionSubscribers();
  initializeCollectionsSubscribed();
  initializeFeedFollowees();
  initializeFeedStoriesRelationships();
  initializeFeedCollectionsByOwner();
  initializeDiscoverTrendingCollections();
  initializeDiscoverLogicCircleStories();
  initializeHomeFeatured();
  initializeCollectionSubscribersEmails();
  initializeCollectionSubscribersUnsubscribed();
  initializeAppCollections();
  initializeAccountCollections();
  resetPaginationSessionCaches();
}

UserAccount.onStateUpdate((_, state) => {
  if (state) initializePaginationCaches();
});

// Lazy route chunks can load after login; catch up so pagers still initialize.
if (UserAccount.isLoggedIn) initializePaginationCaches();

function getSearchCache(cache, keys) {
  let cacheByKey = {};

  const getCache = (search, team, filters) => {
    const key = `${search}_${team}_${JSON.stringify(filters)}`;
    if (cacheByKey[key]) return cacheByKey[key];
    cacheByKey[key] = getPagination(search, team, filters);
    return cacheByKey[key];
  }

  function getPagination(search, team, filters) {
    return new Pagination((i) => ({
      search,
      team: team || '',
      ...(keys || {}),
      ...(filters || {}),
      company,
      state: 'Live',
      page: i,
    }), cache);
  }

  const initialize = () => {
    Object.values(cacheByKey).forEach((cache) => {
      cache.initialize();
    });
    cacheByKey = {};
  };

  return { getCache, initialize };
}
function getCacheByKey(cache, keyKey, query, pageSize = 20) {
  let cacheByKey = {};

  const queryByKey = (key, filter) => new Pagination((i) => {
    const cacheQuery = {
      limit: pageSize,
      offset: (i - 1) * pageSize,
      ...query
    }
    if (Array.isArray(keyKey)) {
      keyKey.forEach((_keyKey, i) => {
        cacheQuery[filter ? `${_keyKey}[${filter}]` : _keyKey] = Array.isArray(key) ? key[i] : key;
      });
    } else if (keyKey) {
      cacheQuery[filter ? `${keyKey}[${filter}]` : keyKey] = key;
    }
    return cacheQuery;
  }, cache, pageSize);

  const getCache = (key, filter) => {
    const keyIndex = `${key}[${filter}]`;
    if (cacheByKey[keyIndex]) return cacheByKey[keyIndex];
    cacheByKey[keyIndex] = queryByKey(key, filter);
    return cacheByKey[keyIndex];
  }

  const initialize = () => {
    Object.values(cacheByKey).forEach((cache) => {
      cache.initialize();
    });
    cacheByKey = {};
  };

  return { getCache, initialize };
}
